





















































































	import { Vue, Component } from "vue-property-decorator";
	import CardTitle from "../../components/CardTitle.vue";
	import DetailsDataTable from "../../components/DataTables/DetailsDataTable.vue";
	import * as user from "../../_store/user.module";
	import * as data from "../../_store/data.module";
	import { bus } from "../../main";
	import { userUtils } from "../../_utils/userUtils";
	import * as auth from "../../_store/auth.module";
	import { createFileRendicontoPCTO, createFileStatisticheAttivita, ExcelUtils } from "../../_utils/excelUtils";
	import * as temp from "../../_store/temp.module";

@Component({
	components: {
		CardTitle,
		DetailsDataTable
	}
})

export default class Statistiche extends Vue {
	private titleParams: object;

	private loadingRendicontazionePCTO: boolean = false;
	private loadingAttivitaReport: boolean = false;
	private loadingAnniScolastici: boolean = false;

	private datiReportPCTO: any[] = [];
	private datiReportAttivita: any[] = [];

	private anniScolastici: any[] = [];
	private selectedAnnoScolastico: number | null = null;

	constructor() {
		super();
		this.titleParams = {
			title: "Statistiche",
			cols: "12",
			sm: "5",
			md: "5",
			lg: "4"
		};
	}

	async downloadRendicontazionePCTOReport() {
		this.loadingRendicontazionePCTO = true;
		try {
			var idAnnoScolastico = parseInt(this.selectedAnnoScolastico as unknown as string);
			var instituteInfo = user.readInstituteInfo(this["$store"]);

			var payload = {
				idAnnoScolastico: idAnnoScolastico,
				idIstituto: instituteInfo.id
			}

			await data.dispatchDownloadRendicontazionePCTOReport(this["$store"], payload)
				.then(async (result: any) => {
					await createFileRendicontoPCTO(result, 'Rendiconto_PCTO' );

					bus.$emit("successfullOperation", "Report PCTO scaricato con successo");
					this.loadingRendicontazionePCTO = false;
				})
				.catch((error: any) => {
					throw error;
				})
		} catch (error) {
			console.error("Errore download report rendicontazione PCTO:", error);
			bus.$emit("errorOperation", "Errore durante il download del report rendicontazione PCTO");
			this.loadingRendicontazionePCTO = false;
		}
	}

	async loadRendicontazioneData() {
		try {
			this.datiReportPCTO = [
				{
					cognomeStudente: "Rossi",
					nomeStudente: "Mario",
					codiceFiscale: "RSSMRA01A01H501Z",
					classe: "5A INF",
					annoScolastico: "2024/2025",
					tipoAttivita: "Tirocinio Estivo",
					denominazioneAzienda: "Tech Solutions S.r.l.",
					dataInizio: "2024-06-15",
					dataFine: "2024-07-15",
					orePreviste: 120,
					oreSvolte: 118,
					statoAttivita: "Completato",
					tutorScolastico: "Prof. Bianchi Giuseppe",
					tutorAziendale: "Ing. Verdi Marco",
					valutazione: "Eccellente",
					note: "Ottima collaborazione"
				},
				{
					cognomeStudente: "Bianchi",
					nomeStudente: "Giulia",
					codiceFiscale: "BNCGLI02B02H501Y",
					classe: "5B INF",
					annoScolastico: "2024/2025",
					tipoAttivita: "Alternanza",
					denominazioneAzienda: "Digital Innovation S.p.A.",
					dataInizio: "2024-09-01",
					dataFine: "2024-12-20",
					orePreviste: 90,
					oreSvolte: 85,
					statoAttivita: "In corso",
					tutorScolastico: "Prof.ssa Neri Anna",
					tutorAziendale: "Dott.ssa Gialli Laura",
					valutazione: "Buono",
					note: "Studente molto motivato"
				},
				{
					cognomeStudente: "Verdi",
					nomeStudente: "Luca",
					codiceFiscale: "VRDLCU03C03H501X",
					classe: "4A INF",
					annoScolastico: "2024/2025",
					tipoAttivita: "Tirocinio Formativo",
					denominazioneAzienda: "Web Development Inc.",
					dataInizio: "2024-10-01",
					dataFine: "2024-11-30",
					orePreviste: 80,
					oreSvolte: 80,
					statoAttivita: "Completato",
					tutorScolastico: "Prof. Gialli Roberto",
					tutorAziendale: "Ing. Rossi Alessandro",
					valutazione: "Ottimo",
					note: "Eccellenti competenze tecniche"
				}
			];
		} catch (err) {
			console.error("Errore nel caricamento dati rendicontazione:", err);
			throw err;
		}
	}

	async loadAnniScolastici() {
		await data
			.dispatchAnniScolastici(this["$store"])
			.then(result => {
				result.forEach((element: any) => {
					this.anniScolastici = result
				});
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", error.response.statusText);
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", error.response.statusText);
				}
			});
	}

	async downloadAttivitaReport() {
		this.loadingAttivitaReport = true;
		try {
			var idAnnoScolastico = parseInt(this.selectedAnnoScolastico as unknown as string);
			var instituteInfo = user.readInstituteInfo(this["$store"]);

			var payload = {
				idAnnoScolastico: idAnnoScolastico,
				idIstituto: instituteInfo.id
			}

			await data.dispatchDownloadAttivitaReport(this["$store"], payload)
				.then(async (result: any) => {
					await createFileStatisticheAttivita(result, 'Statistiche_Attivita' );

					bus.$emit("successfullOperation", "Report attività scaricato con successo");
					this.loadingAttivitaReport = false;
				})
				.catch((error: any) => {
					throw error;
				})
		} catch (error) {
			console.error("Errore download report attività:", error);
			bus.$emit("errorOperation", "Errore durante il download del report attività");
			this.loadingAttivitaReport = false;
		}
	}

	created() {
		var token = localStorage.getItem("userToken");
		var parsedToken: any;
		if (token !== null) {
			parsedToken = userUtils.parseToken(token);
		}
		var payload = {
			idUtente: parsedToken.IdUtente,
			tipoSoggetto: parsedToken.IdTipoSoggetto,
			username: parsedToken.Username
		};
		user
			.dispatchSetUserInfo(this["$store"], payload)
			.then(() => {
				user
					.dispatchSetInstituteInfo(this["$store"])
					.then(async () => {
						await this.loadAnniScolastici();

						this.selectedAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
						bus.$emit("loadMenu");
					})
					.catch(() => {
						bus.$emit("stopLoading");
						auth.dispatchLogout(this["$store"]);
						user.dispatchClearState(this["$store"]);
						this["$router"].push("/sessionExpired");
					});
			})
			.catch(() => {
				bus.$emit("stopLoading");
				auth.dispatchLogout(this["$store"]);
				user.dispatchClearState(this["$store"]);
				this["$router"].push("/sessionExpired");
			});
	}
}
